import React from "react"
import Map from "../shared/about/Map"

const parameters = 'pb=!1m18!1m12!1m3!1d3200.775089251652!2d139.0604459!3d36.655861!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601e43002fffb2cd%3A0xb4cafb660dfe12a5!2sone!5e0!3m2!1sja!2sjp!4v1747295119647!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>'

const AboutMap = () => {
  return <Map parameters={ parameters } />
}

export default AboutMap
